import type { BlockAbstract } from '@lighthouse/core'

import {
    getDefaultCapsuleBtnOrNode,
    getDefaultCombinationBlocksOrNode,
    getDefaultHighlightBlocksOrNode,
    getDefaultIconBtnOrNode
} from '@/constants/Block/combination'
import type { BlockInitConfigOption } from '@/constants/Block/help'
import { getBlockInitConfig } from '@/constants/Block/help'
import type { BlockTreeItem } from '@/constants/Block/type'

type Params = {
    v: BlockTreeItem
    primaryColorId: string
} & BlockInitConfigOption

export function getBlockOrNode(mainBreakPoint: string, params: Params): BlockAbstract | undefined {
    const { v, appId, dataSource, primaryColorId, theme } = params
    if (v.type === 'combinationTitle') {
        return getDefaultCombinationBlocksOrNode(mainBreakPoint, primaryColorId)
    }
    if (v.type === 'highlight') {
        return getDefaultHighlightBlocksOrNode(mainBreakPoint)
    }

    if (v.type === 'iconButton') {
        return getDefaultIconBtnOrNode(mainBreakPoint)
    }
    if (v.type === 'capsuleButton') {
        return getDefaultCapsuleBtnOrNode(mainBreakPoint)
    }

    return getBlockInitConfig(mainBreakPoint, v, {
        appId,
        dataSource,
        theme
    })
}
